// TODO: Document/Rework the approach by VRBOSHOP-1987
// Required to tie MAB reward event payload from the last evaluation with a following action on PDP
const MAB_PAYLOAD_ITEM = 'edap:mabEventJson';

const setItem = (key, value) => {
    try {
        return window.sessionStorage.setItem(key, value);
    } catch (e) {
        return null;
    }
};

const resetMabSessionPayload = () => {
    if (window && window.sessionStorage) {
        window.sessionStorage.removeItem(MAB_PAYLOAD_ITEM);
    }
};

const getJSONItem = (key) => {
    try {
        return JSON.parse(window.sessionStorage.getItem(key));
    } catch (e) {
        return null;
    }
};

export {setItem, getJSONItem, resetMabSessionPayload, MAB_PAYLOAD_ITEM};
